import React from 'react';
import { useGlobalTimelog } from '@/hooks/system/useGlobalTimelog.ts';
import { Button } from '@/components/ui/button';
import { Clock, Play, Pause, AlertCircle } from 'lucide-react';

export const GlobalTimelog: React.FC = () => {
  const { 
    formattedTime, 
    isPaused, 
    isManuallyPaused, 
    isTabInactive, 
    togglePause,
    isVisible 
  } = useGlobalTimelog();
  
  // Don't render if user doesn't have access
  if (!isVisible) {
    return null;
  }
  
  return (
    <div id="global_timelog_container" className="bg-blue-50 border border-blue-200 px-4 pr-0 h-[40px] rounded-full flex items-center">
      {/* Timer icon */}
      <Clock className="h-4 w-4 text-blue-600" />
      
      {/* Timer display */}
      <div className="flex items-center space-x-2 ml-3">
        <span id="global_timelog_display" className="text-sm font-mono font-bold text-blue-800 tracking-wide">
          {formattedTime}
        </span>
        
        {/* Status indicators */}
        {isTabInactive && (
          <div id="global_timelog_inactive_indicator" className="flex items-center space-x-1">
            <AlertCircle className="h-3 w-3 text-orange-500" />
            <span className="text-xs text-orange-600">Tab Inactive</span>
          </div>
        )}
        
        {isManuallyPaused && !isTabInactive && (
          <span id="global_timelog_paused_indicator" className="text-xs text-yellow-600 font-medium">Paused</span>
        )}
      </div>
      
      {/* Pause/Resume button */}
      <Button
        id="global_timelog_toggle_btn"
        size="sm"
        variant="outline"
        onClick={togglePause}
        className={`
          px-3 py-2 ml-[5px] rounded-full transition-colors duration-200 bg-white/20 hover:bg-blue-100 border-0 text-blue-600 hover:text-blue-700
        `}
        title={isPaused ? 'Resume Timer' : 'Pause Timer'}
      >
        {isPaused ? (
          <Play className="h-3 w-3" />
        ) : (
          <Pause className="h-3 w-3" />
        )}
      </Button>
    </div>
  );
};
